module.exports = __webpack_public_path__ + "d8fdeb0f7a933e9ff8ce7ab7f65ad0a4.jpg";